export const paymentType = Object.freeze({
  SINGLE: "single",
  RECURRING: "recurring",
  RECURRING_PRORRATED: "recurring-prorrated",
  RECURRING_ALTER: "recurring-alter",
});
